<template>
  <mf-card-container data-userflow-id="step1">
    <span class="title-span">Título e descrição</span>
    <div class="grid-1fr-2fr margin-16-0">
      <div>
        <label for="campaign-title" class="label-campaign">Título da campanha</label>
        <v-text-field
          id="campaign-title"
          v-model="campaign.title"
          outlined
          :error-messages="getTitleErrorMessages"
          :disabled="disableFields"
          counter
          maxlength="70"
          data-cy="title"
          placeholder="Título da campanha"
        />
      </div>
      <div>
        <label for="campaign-description" class="label-campaign">Descrição</label>
        <v-text-field
          id="campaign-description"
          v-model="campaign.description"
          outlined
          :error-messages="getDescriptionErrorMessages"
          :disabled="disableFields"
          counter
          maxlength="150"
          data-cy="description"
          placeholder="Descrição"
        />
      </div>
    </div>

    <hr class="custom-hr" />

    <div class="grid-1fr-2fr margin-top-16">
      <div :class="{ 'disabled-module': !$getAllowedModules()['mobile'] }">
        <span class="subtitle-span">Aplicativo</span>
        <label for="campaign-app-title" class="label-app">Título exibido no app</label>

        <template v-if="!$getAllowedModules()['mobile']">
          <mf-tooltip top max-width="300px">
            <template #activator>
              <div>
                <v-text-field
                  id="campaign-app-title"
                  v-model="campaign.appTitle"
                  outlined
                  :error="validations.campaign.appTitle && validations.campaign.appTitle.$error"
                  :error-messages="errorAppTitle"
                  :disabled="true"
                  counter
                  maxlength="30"
                  placeholder="Título do app desabilitado"
                />
              </div>
            </template>
            <span>Fale com o seu consultor para contratar o aplicativo e usar essa opção</span>
          </mf-tooltip>
        </template>
        <template v-else>
          <v-text-field
            id="campaign-app-title"
            v-model="campaign.appTitle"
            outlined
            :error="validations.campaign.appTitle && validations.campaign.appTitle.$error"
            :error-messages="errorAppTitle"
            :disabled="disableFields"
            counter
            maxlength="30"
            placeholder="Semana do consumidor"
          />
        </template>
      </div>

      <div class="max-width-50">
        <span class="subtitle-span color-4b525a margin-bottom-16">Lojas</span>
        <label for="campaign-units" class="label-units"> Lojas participantes da campanha de cupom: </label>
        <mf-select-units-dialog
          id="campaign-units"
          outlined
          :selected-units.sync="campaign.units"
          :unit-error="validations.campaign.units && validations.campaign.units.$error"
          :units="units"
          :tag-list="tagList"
          :group-list="unitsGroups"
          :disabled="disableFields"
          hide-ecommerce-configuration
        />
      </div>
    </div>
  </mf-card-container>
</template>

<script>
import { DateTime } from 'luxon'
import { mapGetters } from 'vuex'

export default {
  name: 'CouponDiscountHeader',
  props: {
    campaign: {
      type: Object,
      default: () => ({}),
    },
    validations: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    disableFields() {
      return ['FINISHED', 'ACTIVE'].includes(this.campaign.status)
    },
    getTitleErrorMessages() {
      return this.errorTitle ? [this.errorTitle] : []
    },
    getDescriptionErrorMessages() {
      return this.errorDescription ? [this.errorDescription] : []
    },
    errorTitle() {
      const val = this.validations.campaign.title
      if (!val) return ''
      if (val.$error) {
        if (!val.required) return 'Dê um nome para esta campanha.'
        else if (!val.minLength) return 'O título possui menos de 2 caracteres.'
        else if (!val.notOnlySpace) return 'Não é permitido salvar apenas espaços.'
      }
      return ''
    },
    errorDescription() {
      const val = this.validations.campaign.description
      if (!val) return ''
      if (val.$error) {
        if (!val.required) return 'Informe detalhes para melhor identificação da campanha.'
        else if (!val.minLength) return 'A descrição possui menos de 2 caracteres.'
        else if (!val.notOnlySpace) return 'Não é permitido salvar apenas espaços.'
      }
      return ''
    },
    errorAppTitle() {
      const val = this.validations.campaign.appTitle
      if (!val) return ''
      if (val.$error) {
        if (!val.required) return 'Dê um título para ser exibido no app.'
        else if (!val.minLength) return 'O título no app possui menos de 2 caracteres.'
        else if (!val.notOnlySpace) return 'Não é permitido salvar apenas espaços.'
      }
      return ''
    },
    ...mapGetters(['units', 'tagList', 'unitsGroups']),
    todayDate() {
      return DateTime.now().toFormat('yyyy-MM-dd')
    },
    errorSendDate() {
      const valStart = this.validations.campanha?.start_date
      const valEnd = this.validations.campanha?.end_date
      if (valStart?.$error) {
        if (!valStart.required) return 'Selecione uma data de envio.'
        else if (this.campanha.status !== 'active' && !valStart.isFuture) return 'A data de envio deve ser no futuro.'
      }
      if (valEnd?.$error) return 'Período inválido'
      return ''
    },
  },
}
</script>

<style scoped>
.title-span {
  display: block;
  font-size: 20px;
  font-weight: 700;
  color: #31363b;
  margin-bottom: 16px;
}

.grid-1fr-2fr {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 24px;
}

.margin-16-0 {
  margin: 16px 0;
}

.custom-hr {
  border: none;
  border-top: 1px solid #c3c8cd;
}

.margin-top-16 {
  margin-top: 16px;
}

.label-campaign {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #4b525a;
  margin-bottom: 8px;
}

.subtitle-span {
  font-size: 18px;
  font-weight: 700;
}

.disabled-module {
  opacity: 0.5;
  color: #999 !important;
}

.label-app {
  display: block;
  font-size: 14px;
  font-weight: 600;
  margin-top: 16px;
  margin-bottom: 8px;
}

.max-width-50 {
  max-width: 50%;
}

.color-4b525a {
  color: #4b525a;
}

.margin-bottom-16 {
  margin-bottom: 16px;
}

.label-units {
  display: block;
  font-size: 14px;
  font-weight: 400;
  color: #656565;
  margin-top: 16px;
  margin-bottom: 8px;
}

@media (max-width: 1160px) {
  .grid-1fr-2fr {
    grid-template-columns: 1fr 1fr;
  }

  .grid-1fr-2fr > div {
    width: 100%;
  }

  .max-width-50 {
    max-width: 100%;
  }
}

@media (max-width: 690px) {
  .grid-1fr-2fr {
    grid-template-columns: 1fr;
  }

  .grid-1fr-2fr > div {
    width: 75%;
  }

  .max-width-50 {
    max-width: 75%;
  }
}
</style>
